export const EXPERIENCE_DATA = [
  {
    name: "Gameskraft",
    logo: "https://ca.slack-edge.com/E0564FESH0D-U057BMVK2LU-067862fa8ecd-512",
    type: "Full-time",
    duration: "3 yrs 9 mos",
    roles: [
      {
        title: "Senior Software Engineer",
        period: "Apr 2022 – Present",
        totalDuration: "3 yrs 2 mos",
        location: "Bengaluru, Karnataka, India",
        skills: "Performance Management, Pipelines and +15 skills",
      },
      {
        title: "Software Engineer",
        period: "Sep 2021 – Mar 2022",
        totalDuration: "7 mos",
        location: "Bengaluru, Karnataka, India",
        skills: "JavaScript, React Native and +9 skills",
      },
    ],
  },

  {
    name: "Pocket52",
    logo: "https://files.slack.com/files-tmb/T0564FESH0D-F08U0REG83U-40dea21833/playship_logo_360.png",
    type: "Full-time",
    duration: "11 mos",
    roles: [
      {
        title: "Software Engineer - 1",
        period: "Nov 2020 – Sep 2021",
        totalDuration: "11 mos",
        location: "Bengaluru, Karnataka, India",
        skills: "React, Javascript, Android, Jetpack +4 skills",
      },
    ],
  },

  {
    name: "Recro",
    logo: "https://media.licdn.com/dms/image/v2/D560BAQH7GYOGBCj8Qg/company-logo_200_200/company-logo_200_200/0/1728907260215/recro_io_logo?e=1753920000&v=beta&t=-vzJukPg663aZtFeTO_Txu7T43Jh9uphdSUM9AQLKTQ",
    type: "Full-time",
    duration: "1 yrs 9 mos",
    roles: [
      {
        title: "Software Engineer",
        period: "Dec 2018 – Nov 2020",
        totalDuration: "1 yrs 9 mos",
        location: "Bengaluru, Karnataka, India",
        skills: "Android, Java, Kotlin, HTML, CSS +5 skills",
      },
    ],
  },
];
